import script from "./PillsTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./PillsTag.vue?vue&type=script&setup=true&lang=ts"

import "./PillsTag.vue?vue&type=style&index=0&id=69638761&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69638761"]])

export default __exports__